import React, { Component } from 'react'
import { Button } from 'components';
import FontIcon from 'material-ui/FontIcon'
import FormsyText from 'formsy-material-ui/lib/FormsyText'

import './keywordTags.scss';

export default class KeywordTags extends Component {

  constructor() {
    super()

    this.state = {
      newKeyword: ''
    }

    this.addKeyword = this.addKeyword.bind(this)
    this.removeKeyword = this.removeKeyword.bind(this)
  }

  pushKeyword(input) {
    let kw = input.trim()
    if (kw.length == 0) {
      return false
    }

    let keywords = this.props.keywords

    kw.split(",").forEach(raw => {
      let k = raw.trim()
      if (k.length > 0 && !keywords.includes(k)) {
        keywords.push(k)
      }
    })

    this.props.handleState(keywords)
    this.setState({newKeyword: ''})
    return true
  }

  addKeyword(e) {
    e.preventDefault()

    let kw = this.state.newKeyword.trim()

    this.pushKeyword(kw)
  }

  removeKeyword(keyword) {
    let newKeywords = this.props.keywords

    // remove keyword from array
    newKeywords = newKeywords.filter(newKeyword => newKeyword !== keyword)

    // pass to parent
    this.props.handleState(newKeywords)
  }

  handleInputChange(e) {
    this.setState({ newKeyword : e.target.value }, function() {
      let kw = this.state.newKeyword.trim()
      if (kw.length > 0 && kw.includes(",")) {
        this.pushKeyword(kw)
      }
    })
  }

  render() {
    const keywordTags = [];
    this.props.keywords.map(keyword => {
      keywordTags.push(
        <li
          key={keyword}
        >
          {keyword}
          <FontIcon onClick={this.removeKeyword.bind(this, keyword)} className="material-icons check-keywords__remove-tag" style={{fontSize: 16}}>close</FontIcon>
        </li>
      )
    })

    return (
      <div className="check-keywords">
        <ul className="check-keywords__tags">
          {keywordTags}
        </ul>
        <div className="check-keywords__input">
          <FormsyText
            name='keywords'
            multiLine={false}
            autoComplete="off"
            value={this.state.newKeyword}
            onChange={::this.handleInputChange}
            hintText="Add a target keyword or phrase"
            className="setup__form-field"
          />
          <Button
            type='Submit'
            buttonType="secondary"
            label='Add'
            onClick={::this.addKeyword}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checker/KeywordTags.js